import * as t from './actionTypes';

export const initialState = {
  // TODO: [AUD-2223]: update to 'And' once FF is removed
  combinator: 'Or',
  hasDynamicFields: false,
  fields: {},
  fieldOptions: {},
  properties: [],
  searchQueries: [],
  undoStack: [],
  presentState: {},
  redoQueue: [],
  catalogName: '',
};

const segmentationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.INITIALIZE_QUERY: {
      return { ...state, ...action.queryBuilderProps };
    }
    case t.TOGGLE_VIEW_MODE:
    case t.TOGGLE_EDIT_MODE: {
      return { ...state, isViewMode: action.isViewMode };
    }
    case t.UPDATE_QUERY: {
      return {
        ...state,
        combinator: action.combinator,
        hasDynamicFields: action.hasDynamicFields,
        searchQueries: action.searchQueries,
        redoQueue: [],
        undoStack: [...state.undoStack, state.presentState],
        presentState: action.presentState,
      };
    }
    case t.UPDATE_QUERY_ERROR: {
      return { ...state, error: action.error };
    }
    case t.VALIDATE_QUERY_RESPONSE: {
      return {
        ...state,
        showValidations: action.showValidations,
        validationMessages: action.validationMessages,
      };
    }
    case t.UPDATE_QUERY_FROM_STATE:
    case t.INITIALIZE_QUERY_RESPONSE: {
      return {
        ...state,
        combinator: action.combinator,
        hasDynamicFields: action.hasDynamicFields,
        searchQueries: action.searchQueries,
        presentState: action.presentState,
        redoQueue: action.redoQueue,
        undoStack: action.undoStack,
      };
    }
    case t.RESET_QUERY_BUILDER:
      return initialState;

    /*--------------------------------------------------------------------------------------------*/
    /* Limit And Order By Actions                                                                 */
    /*--------------------------------------------------------------------------------------------*/
    case t.CHANGE_QUERY_ORDER_BY: {
      return { ...state, orderBy: action.orderBy };
    }
    case t.CHANGE_QUERY_SIZE_LIMIT: {
      return { ...state, sizeLimit: action.sizeLimit };
    }

    /*--------------------------------------------------------------------------------------------*/
    /* Recommendations Actions                                                                    */
    /*--------------------------------------------------------------------------------------------*/
    case t.SET_USES_SMART_RECOS: {
      return { ...state, usesSmartRecos: action.usesSmartRecos, orderBy: {} };
    }

    /*--------------------------------------------------------------------------------------------*/
    /* Fetching Query Actions                                                                     */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_QUERY: {
      return { ...state, isFetchingQuery: action.isFetchingQuery };
    }
    case t.FETCH_QUERY_ERROR: {
      return { ...state, error: action.error, isFetchingQuery: action.isFetchingQuery };
    }
    case t.FETCH_QUERY_RESPONSE: {
      return {
        ...state,
        combinator: action.combinator,
        hasDynamicFields: action.hasDynamicFields,
        orderBy: action.orderBy,
        sizeLimit: action.sizeLimit,
        searchQueries: action.searchQueries,
        undoStack: [],
        presentState: action.presentState,
        redoQueue: [],
        isFetchingQuery: action.isFetchingQuery,
        usesSmartRecos: action.usesSmartRecos,
      };
    }

    /*--------------------------------------------------------------------------------------------*/
    /* Fetching Query Properties Actions                                                          */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_QUERY_PROPERTIES: {
      return { ...state, isFetchingProperties: action.isFetchingProperties };
    }
    case t.FETCH_QUERY_PROPERTIES_ERROR: {
      return { ...state, error: action.error, isFetchingProperties: action.isFetchingProperties };
    }
    case t.FETCH_QUERY_PROPERTIES_RESPONSE: {
      return {
        ...state,
        properties: action.properties,
        isFetchingProperties: action.isFetchingProperties,
      };
    }

    /*--------------------------------------------------------------------------------------------*/
    /* Fields Actions                                                                             */
    /*--------------------------------------------------------------------------------------------*/
    case t.UPDATE_FIELDS_FOR_PROPERTY_RESPONSE: {
      return { ...state, fields: action.fields };
    }

    case t.UPDATE_OPTIONS_FOR_FIELD_RESPONSE: {
      return { ...state, fieldOptions: action.fieldOptions };
    }
    /*--------------------------------------------------------------------------------------------*/
    /* Cloning Actions                                                                     */
    /*--------------------------------------------------------------------------------------------*/
    case t.SET_CLONING_VALIDATION_MESSAGES: {
      return {
        ...state,
        cloningValidationMessages: action.validations,
      };
    }

    /*------------------------------------------------------------------------------------------------*/
    /* Catalog Actions                                                                                 */
    /*------------------------------------------------------------------------------------------------*/
    case t.CHANGE_CATALOG_NAME:
      return { ...state, catalogName: action.catalogName };

    default: {
      return state;
    }
  }
};

export default segmentationReducer;
